export const STORE_THEMES = [
    {
        id: "sky_blue",
        name: "Azul Celeste",
        colors: {
            orange: "#38bdf8",
            orangeHover: "#0ea5e9",
            navy: "#0f172a",
            navySoft: "#1e293b",
            bg: "#f8fafc",
            muted: "#e2e8f0",
            border: "#cbd5e1",
            text: "#0f172a",
            textMuted: "#475569",
        },
    },
    {
        id: "deep_blue",
        name: "Azul Profundo",
        colors: {
            orange: "#2563eb",
            orangeHover: "#1d4ed8",
            navy: "#0b1120",
            navySoft: "#172033",
            bg: "#f8fafc",
            muted: "#e5e7eb",
            border: "#cbd5e1",
            text: "#0f172a",
            textMuted: "#4b5563",
        },
    },
    {
        id: "blue_amber",
        name: "Celeste y Ámbar",
        colors: {
            orange: "#38bdf8",
            orangeHover: "#0ea5e9",
            navy: "#0f172a",
            navySoft: "#1e293b",
            bg: "#fffdf7",
            muted: "#fef3c7",
            border: "#fde68a",
            text: "#111827",
            textMuted: "#6b7280",
        },
    },
    {
        id: "blue_graphite",
        name: "Azul Grafito",
        colors: {
            orange: "#22d3ee",
            orangeHover: "#06b6d4",
            navy: "#111827",
            navySoft: "#1f2937",
            bg: "#f9fafb",
            muted: "#e5e7eb",
            border: "#d1d5db",
            text: "#111827",
            textMuted: "#4b5563",
        },
    },
    {
        id: "blue_white",
        name: "Celeste Minimal",
        colors: {
            orange: "#0ea5e9",
            orangeHover: "#0284c7",
            navy: "#0f172a",
            navySoft: "#1e293b",
            bg: "#ffffff",
            muted: "#f1f5f9",
            border: "#cbd5e1",
            text: "#0f172a",
            textMuted: "#64748b",
        },
    },
    {
        id: "blue_mint",
        name: "Azul Menta",
        colors: {
            orange: "#2dd4bf",
            orangeHover: "#14b8a6",
            navy: "#0f172a",
            navySoft: "#1e293b",
            bg: "#f0fdfa",
            muted: "#ccfbf1",
            border: "#99f6e4",
            text: "#0f172a",
            textMuted: "#475569",
        },
    },
    {
        id: "sunset_cyan",
        name: "Cian Atardecer",
        colors: {
            orange: "#06b6d4",
            orangeHover: "#0891b2",
            navy: "#172554",
            navySoft: "#1e3a8a",
            bg: "#fff7ed",
            muted: "#ffedd5",
            border: "#fed7aa",
            text: "#1e293b",
            textMuted: "#64748b",
        },
    },
];

export const DEFAULT_STORE_THEME_ID = "sky_blue";

export function getThemeById(themeId) {
    return STORE_THEMES.find((t) => t.id === themeId) || STORE_THEMES[0];
}

export function applyStoreTheme(themeId) {
    if (typeof document === "undefined") return;
    const theme = getThemeById(themeId || DEFAULT_STORE_THEME_ID);
    const root = document.documentElement;
    root.style.setProperty("--lz-orange", theme.colors.orange);
    root.style.setProperty("--lz-orange-hover", theme.colors.orangeHover);
    root.style.setProperty("--lz-navy", theme.colors.navy);
    root.style.setProperty("--lz-navy-soft", theme.colors.navySoft);
    root.style.setProperty("--lz-bg", theme.colors.bg);
    root.style.setProperty("--lz-muted", theme.colors.muted);
    root.style.setProperty("--lz-border", theme.colors.border);
    root.style.setProperty("--lz-text", theme.colors.text);
    root.style.setProperty("--lz-text-muted", theme.colors.textMuted);
}
